"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gammaPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var gammaPalette = {
  gamma10: '#EBE5F2',
  gamma30: '#DDD0EA',
  gamma60: '#C1A7D9',
  gamma: '#9B70C4',
  gammaDark: '#633093',
  gammaDarkest: '#390D62'
};
exports.gammaPalette = gammaPalette;